<div class="th-menulevel">
  <div class="ir-btn ir-btn--big th-btn-menulevel" (click)="selectMenu(15)">
    <span>{{ 'menus.export-users' | translate }}</span>
  </div>
</div>
